import ItineraryService from '../services/itinerary';
import MapService from '../../services/map';
import {TabsItineraryTransport} from '../enumerator/tabs.enum';
import Translate from '../../services/translate';

/**
 * -------------
 * Itinerary
 * -------------
 * @description
 * gère les événements de la page calcul-itineraire.php
 * */
export default class Itinerary {

    /** Les tabs */
    static tabs = TabsItineraryTransport;

    constructor() {
        // init
        const options = {
            id: 'mapItinerary',
            style: Translate.print('map.itinerary'),
            zoom: 5.3,
            center: [1.5, 46.7],
            scrollZoom: true,
            interactive: true,
        }
        MapService.initMap(options).then(function () {
            ItineraryService.initItinerary();
            Itinerary.initSlider();
        });

        // listeners
        $(document).on('click', '[data-itinerary-showDetails]', ItineraryService.openDetail);
        $(document).on('click', '[data-itinerary-detail-close]', ItineraryService.closeDetail);
        $(document).on('click', '[data-itinerary-detail-stops]', ItineraryService.toggleShowStopsDetail);
        $('[data-itinerary-slider]').on('afterChange', function (event, slick) {
            ItineraryService.swiperIndexChange(slick.currentSlide);
        });
    }

    /**
     * -------------
     * initSlider
     * -------------
     * @description
     * Initialise le slider de résultats
     * */
    static initSlider = function () {
        $('[data-itinerary-slider]').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: false,
            speed: 500,
            padding: 0,
            variableWidth: true,
            nextArrow:
                '<div class="slider-navigation slider-next"></div>',
            prevArrow:
                '<div class="slider-navigation slider-prev"></div>',
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });

        $('[data-itinerary-slider]').on('click', '.item:not(.slick-current)', function(e) {
            e.preventDefault();
            $('[data-itinerary-slider]').slick('slickGoTo', $(this).data('slick-index'));
        });
    }
}
